var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"ban02",attrs:{"id":"banner01"}},[_c('el-carousel',{attrs:{"height":"140px"}},_vm._l((_vm.slideData),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"slidimg",attrs:{"src":item.imgUrl?_vm.baseUrl+item.imgUrl:_vm.defaultimg,"alt":item.title}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }